module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/asset/gold_medal.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/asset/gold_medal.png
// module id = 492
// module chunks = 418